import { useEffect } from "react";
import OnlyLogged from "../OnlyLogged";
import { useAccount } from "wagmi";
import Paywall from "./Paywall";
/* const isDev =
Boolean(process.env.REACT_APP_IS_DEV_MODE) || false; */
const AuthenticatedContainer = ({ children }) => {
  const account = useAccount();
  useEffect(() => {
    console.log("TEST efc");
  }, [account]);
  return (
    <>
      {(account?.isConnected && account?.address) ? (
        <Paywall address={account.address}>{children}</Paywall>
      ) : (
        <OnlyLogged />
      )}
    </>
  );
};
export default AuthenticatedContainer;
